import React from 'react'

interface OtherProps extends playground.Other_Object {
  isEditMode: boolean
}

const Others: React.FC<OtherProps> = ({ isEditMode, ...object }) => {
  const { id, isSelected = false, type, name, rotation, x, y, width, height, visualStatus, style } = object
  const magMainRef = React.useRef(null)


  return (
    <div
      id={`object_${id}`}
      className='object --other'
      style={{
        left: x,
        top: y,
      }}>

      <div
        ref={magMainRef}
        className={`object__main${isSelected ? ' --selected' : ''}`}
        style={(() => {
          const base = {
            width: `${width}px`,
            height: `${height}px`,
            rotate: `${rotation}deg`,
            flexDirection: height < 80 ? 'row' : 'column'
          } as React.CSSProperties
          return isEditMode ? base : { ...style, ...base }
        })()}>

        {(type === 'gate' || type === 'gateway')
          ? <div className={`object__progress --${getProgressMod(visualStatus)}`} />
          : <div
            className='object__note'
            style={rotation ? { rotate: `${-rotation}deg` } : undefined}>
            {name}
          </div>}
      </div>
    </div>
  )
}

const getProgressMod = (status?: socket.GateEvent | socket.GatewayEvent) => {
  switch (status) {
    case 'gate_opened':
    case 'gateway_opened':
      return 'opened'
    case 'gate_opening':
      return 'opening'
    case 'gate_closing':
      return 'closing'
    case 'gate_closed':
    case 'gateway_closed':
      return 'closed'
    case 'gateway_unlocked':
      return 'unlocked'
    default: return ''
  }
}

export default Others